import Vue from "vue";
import { LOCAL, ROOT } from "@/store/mutations";

const { ACTIVATE_HINT, HINT_TRIGGER_SUBSCRIBE, HINT_TRIGGER_SET_STATUS, COMPLETE_HINT } = LOCAL;
const { SET_CHAPTER_INDEX, ROUTE_CHANGED } = ROOT;

export default {
	namespaced: true,
	state: {
		id: null,
		complete: false,
		active: false,
		triggers: {},
		content: "",
		position: "",
		close_button_text: "",
	},
	getters: {
		triggerList: (state) => Object.values(state.triggers),
		sceneMatches: () => (trigger, transition) => transition[trigger.direction].name === trigger.scene,
		chapterMatches: () => (trigger, { index }) => (trigger.chapter - 1) === index,
		activate: (state, getters) => getters.triggerList.every((trigger) => trigger.activated),
	},
	actions: {
		listen({ dispatch, getters }) {
			getters.triggerList.forEach((trigger) => {
				let payload = { ...trigger };

				switch (trigger.type) {
				case "scene":
					payload = { ...payload, getter: "sceneMatches", mutation: ROUTE_CHANGED };
					break;
				case "chapter":
					payload = { ...payload, getter: "chapterMatches", mutation: SET_CHAPTER_INDEX };
					break;
				default:
					break;
				}

				dispatch("subscribe", payload);
			});
		},
		subscribe({ state, commit, getters }, trigger) {
			const unsubscribe = this.subscribe((mutation) => {
				if (mutation.type !== trigger.mutation) {
					return;
				}

				const activate = getters[trigger.getter](trigger, mutation.payload);

				if (!state.triggers[trigger.id].activated && activate) {
					commit(HINT_TRIGGER_SET_STATUS, { ...trigger, active: true });
				} else if (state.triggers[trigger.id].activated && !activate) {
					commit(HINT_TRIGGER_SET_STATUS, { ...trigger, active: false });
				}

				if (getters.activate) {
					commit(ACTIVATE_HINT);
				}
			});

			commit(HINT_TRIGGER_SUBSCRIBE, { ...trigger, unsubscribe });
		},
		complete({ commit }) {
			commit(COMPLETE_HINT);
		},
	},
	mutations: {
		[HINT_TRIGGER_SUBSCRIBE](state, trigger) {
			Vue.set(state.triggers[trigger.id], "activated", false);
			Vue.set(state.triggers[trigger.id], "unsubscribe", trigger.unsubscribe);
		},
		[HINT_TRIGGER_SET_STATUS](state, trigger) {
			Vue.set(state.triggers[trigger.id], "activated", trigger.active);
		},
		[ACTIVATE_HINT](state) {
			state.active = true;
			Object.values(state.triggers).forEach((trigger) => trigger.unsubscribe());
		},
		[COMPLETE_HINT](state) {
			state.active = false;
			state.complete = true;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/hints/single.store.js